import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b0df5a7")

_pushScopeId("data-v-3b0df5a7")
const _hoisted_1 = {
  class: "ui__baseInfo_main",
  id: "BaseInfo"
}
const _hoisted_2 = { class: "ui__baseInfo_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__line_main" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_componentTitle = _resolveComponent("componentTitle")
  const _component_infoList = _resolveComponent("infoList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_componentTitle, { title: "基础信息" }),
      _createVNode(_component_infoList, {
        dataList: _ctx.state.dataList,
        direction: ""
      }, null, 8, ["dataList"])
    ]),
    _hoisted_3
  ]))
})